import { GameEvent } from '../events/gameEvent';
import { EventName } from '../events/eventsName';
import { Store } from 'game/store/gameStore';
import { MagicUIParticles } from 'game/MagicUIParticles';
import { SoundManager } from 'game/core/soundManager';
import { GAEvent, GAEventNames } from 'game/analytics/events';
import { GameActionButton } from './GameActionButton';

export class MagicWandButton extends GameActionButton {
    constructor(index: number) {
        super('wand', index);
        this.modalClosed = this.modalClosed.bind(this);

        GameEvent.add(EventName.CLOSE_MODAL, this.modalClosed);
        GameEvent.add(EventName.NO_MAGIC_KING_INFO, this.onNoMagicKingInfo.bind(this));
    }
    onNoMagicKingInfo() {
        this.blockButton(Infinity);
    }

    modalClosed({ id, confirm }: { id: string; confirm: boolean }) {
        const gameData = {
            id: Store.gameId,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
        };
        if (id === 'magic-wand' && confirm) {
            this.onboardingConfirm();
        }
        if (id === 'out-wand') {
            if (confirm) {
                GAEvent(GAEventNames.MAGIC_WAND_NO_MOVES_CONFIRM, gameData);
                this.onClick();
            } else {
                GAEvent(GAEventNames.MAGIC_WAND_NO_MOVES_CLOSE, gameData);
            }
        }
        if (id === 'out-move-ads') {
            if (confirm) {
                this.onClick();
                GAEvent(GAEventNames.OUT_MOVE_AD_CONFIRM, gameData);
            } else {
                GAEvent(GAEventNames.OUT_MOVE_AD_CLOSE, gameData);
            }
        }
        if (id === 'out-move-wand') {
            if (confirm) {
                GAEvent(GAEventNames.OUT_MOVE_WAND_POPUP_CONFIRM, gameData);
                this.onClick();
            } else {
                GAEvent(GAEventNames.OUT_MOVE_WAND_POPUP_CLOSE, gameData);
            }
        }
    }
    onboardingConfirm() {
        this.onClick();
        GAEvent(GAEventNames.MAGIC_WAND_ONBOARDING_TRY, {
            id: Store.gameId,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
        });
    }

    onClick() {
        SoundManager.play('magicWandClickSFX');
        if (Store.wandCounter < 1) {
            // if (!Store.hasPopup('out-wand')) {
            //     showPopup('out-wand');
            //     GAEvent(GAEventNames.MAGIC_WAND_NO_MOVES, {
            //         id: Store.gameId,
            //         type: Store.getGameTypeText(),
            //         difficulty: Store.getDifficultyText(),
            //     });
            // } else {
            GameEvent.emit(EventName.SHOW_ADS, { place: 'wand' });
            // }
            return;
        }
        this.wand();
    }
    wand() {
        new MagicUIParticles(this.button);
        GAEvent(GAEventNames.MAGIC_WAND_CLICK, {
            moves: Store.movesCount,
            id: Store.gameId,
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
        });
        GameEvent.emit(EventName.MAGIC_WAND);
    }
    getStoreCounter() {
        return Store.wandCounter;
    }
}
